import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { PlacementDefiscalisationResponse } from '@/api';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

interface TaxExemptionProps {
  readonly data: PlacementDefiscalisationResponse;
}

export default function TaxExemptionDetails({ data }: TaxExemptionProps) {
  const { t } = useTranslation();

  return (
    <table className={styles.contractDetailsTable}>
      <tbody className={styles.contractDetailsList}>
        {data?.gestionnaire !== null && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.managedByLabel')}</p>
            </td>
            <td className={styles.contractDetailsValue}>
              <p>{data?.gestionnaire}</p>
            </td>
          </tr>
        )}
        {data?.statut !== null && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.statusLabel')}</p>{' '}
            </td>
            <td className={styles.contractDetailsValue}>
              <p>{data?.statut === 'ENCOURS' && 'en cours'}</p>
            </td>
          </tr>
        )}
        {data?.categorie !== null && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.categoryLabel')}</p>
            </td>
            <td className={styles.contractDetailsValue}>
              <p>{data?.categorie}</p>
            </td>
          </tr>
        )}
        {data?.annee !== null && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.yearLabel')}</p>{' '}
            </td>
            <td className={styles.contractDetailsValue}>
              <p>{data?.annee}</p>
            </td>
          </tr>
        )}
        {typeof data?.versementInitial === 'number' && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              {' '}
              <p>{t('taxExemption.initialDepositLabel')}</p>
            </td>
            <td className={styles.contractDetailsValue}>
              <p>
                {data?.versementInitial === null
                  ? t('common.infoUnavailable')
                  : t('format.currencyFlexible', { value: data.versementInitial })}
              </p>
            </td>
          </tr>
        )}
        {typeof data?.reducImpotPourcent === 'number' && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.taxReductionLabel')}</p>
            </td>
            <td className={styles.contractDetailsValue}>
              <p>{t('format.percentFlexible', { value: data?.reducImpotPourcent })}</p>
            </td>
          </tr>
        )}
        {data?.blocageMin !== null && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.minLockupLabel')}</p>
            </td>
            <td className={styles.contractDetailsValue}>
              <p>
                {t('taxExemption.lockupUntilLabel')} {data.blocageMin?.split('-').reverse().join('/')}
              </p>
            </td>
          </tr>
        )}
        {data?.blocageMax !== null && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.maxLockupLabel')}</p>{' '}
            </td>
            <td className={styles.contractDetailsValue}>
              <p>
                {t('taxExemption.lockupUntilLabel')} {data.blocageMax?.split('-').reverse().join('/')}
              </p>
            </td>
          </tr>
        )}
        {data?.rapportGestion && (
          <tr className={styles.contractDetailsLine}>
            <td className={styles.contractDetailsTitle}>
              <p>{t('taxExemption.lastManagementReportLabel')}</p>{' '}
            </td>
            <td className={styles.valueDetailsContrat}>
              <p>
                <a
                  className={styles.linkRapportGestion}
                  href={data?.rapportGestion}
                  target="_blank"
                  onClick={() => {
                    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                      event_id: 'clic',
                      event_categorie: 'clic',
                      event_metier: 'espace client placement',
                      event_nom: 'telecharger dernier rapport',
                      event_detail_1: 'picto',
                    });
                  }}
                  rel="noreferrer noopener"
                >
                  <MtxIcon name="eye" size={24} />
                </a>
              </p>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
